module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "txe",
    attrs: {
      "id": "pz4-1"
    }
  }, [_vm._v("Deep calls to deep at the roar of your waterfalls; ")]), _vm._v(" "), _c('p', {
    staticClass: "txe1",
    attrs: {
      "id": "pz4-3"
    }
  }, [_vm._v("all your breakers and your waves have gone over me. ")]), _vm._v(" "), _c('p', {
    staticClass: "txr1",
    attrs: {
      "id": "pz4-5"
    }
  }, [_c('i', [_vm._v("Psalm 42.7")])]), _vm._v(" "), _c('p', {
    staticClass: "txe2",
    attrs: {
      "id": "pz4-6"
    }
  }, [_vm._v("the tempest"), _c('br'), _vm._v(" the darkness"), _c('br'), _vm._v(" the waves that you sent"), _c('br'), _vm._v(" just the saltwater taste"), _c('br'), _vm._v(" of these songs of descent")]), _vm._v(" "), _c('p', {
    staticClass: "txe2",
    attrs: {
      "id": "pz4-11"
    }
  }, [_vm._v("still sinking"), _c('br'), _vm._v(" still losing"), _c('br'), _vm._v(" the waves won’t relent"), _c('br'), _vm._v(" I won’t go down quiet"), _c('br'), _vm._v(" this is a song of dissent.")]), _vm._v(" "), _c('p', {
    staticClass: "txe2",
    attrs: {
      "id": "pz4-16"
    }
  }, [_vm._v("no flailing"), _c('br'), _vm._v(" no swimming"), _c('br'), _vm._v(" I’m not innocent"), _c('br'), _vm._v(" water fills my lungs"), _c('br'), _vm._v(" This is my song of descent.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9599aae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter02.vue
// module id = 66
// module chunks = 0